// Generated by scripts/generate-bundled-plugins.mjs. Do not edit.
import type { AcpAgentCatalogEntry } from './acp-agent-catalog';
export const ACP_AGENT_CATALOG_GENERATED = [
  {
    id: 'cursor',
    localId: 'auto-cursor',
    name: 'Cursor Agent',
    family: null,
    discovery: {
      binaries: ['cursor-agent'],
    },
    launch: {
      args: ['acp'],
    },
    providerInjection: {
      baseUrl: {
        target: 'argument',
        name: '--endpoint',
      },
      auth: {
        target: 'env',
        name: 'CURSOR_API_KEY',
      },
    },
    capabilities: ['models', 'delegation'],
    default: false,
    aliases: [],
    sessionConfig: [],
    plugin: 'com.crowdex.cursor-agent',
  },
  {
    id: 'gemini',
    localId: 'auto-gemini',
    name: 'Gemini CLI',
    family: null,
    discovery: {
      binaries: ['gemini'],
    },
    launch: {
      args: ['--experimental-acp'],
    },
    capabilities: ['models', 'delegation'],
    default: false,
    aliases: [],
    sessionConfig: [],
    plugin: 'com.crowdex.gemini-agent',
  },
  {
    id: 'goose',
    localId: 'auto-goose',
    name: 'Goose',
    family: null,
    discovery: {
      binaries: ['goose'],
    },
    launch: {
      args: ['acp'],
    },
    capabilities: ['models', 'delegation'],
    default: false,
    aliases: [],
    sessionConfig: [],
    plugin: 'com.crowdex.goose-agent',
  },
] as const satisfies readonly AcpAgentCatalogEntry[];
